import { createPinia } from 'pinia';
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import errorHandler from './services/error-handler';

const app = createApp(App);

errorHandler(app);
app.use(createPinia());
app.use(router);
app.mount('#app');
